export const promptHubDefaultPromptId = 'add4bd0e-c548-4390-96d3-7b53e463148b'
export const experimentalTemplatePromptId = 'df8b5627-d01d-445f-8c93-9d38caf933fb'
export const promptHubTonePromptId = '05c03968-bc79-44cd-bfae-46985edc72f6'

export const fileInfoDomain = 'https://files.wix.com/site/media/files'
export const infoPath = 'info'

export const promptHubBusinessNameShorterPromptId = 'aaf4e2f5-a3a6-45b7-9d88-e763e3164d57'
export const promptHubStructurePromptId = '69f7ce91-4309-40ca-b09e-322a495adca2'
export const promptHubNewOutlineStructurePromptId = 'cbd2813b-a271-4c95-8e6c-9ec1c63e926c'
export const promptHubFlatStructurePromptId = '5654e211-0a21-4994-a47d-cb373d1ead73'
export const promptHubFlatStructureWithLangPromptId = '26049616-2409-4132-9f19-cd70753a4a9b'
export const promptHubCharCountPromptId = '129e7801-108a-4b46-862c-f3c1cbb7bfa9'
export const promptHubCharCountExpPromptId = 'a5d99d78-b8f6-4e07-8aca-1acdd9d33964'

export const promptHubLinkGenerationPromptId = '416c27aa-c37c-41a0-9e1c-049329707391'
export const promptHubNewBuilderOutlineDataPromptId = '8880f3db-98a8-463b-8443-f9a180ade676'

export const nonApplicableParamsVersion = 'N/A'

export const aiGatewayUrl = '/_serverless/ai-gateway/ai-prompt'
export const promptHubAppId = 'c4de5ff8-cb71-476c-9208-5dbfca312c15'

export const aiContentOutlineResultErrorType = 'invalidAIContentOutline'
export const aiContentOutlineResultErrorMessage = 'AI Outline result is invalid or does not match the page structure'
export const aiContentOutlineResultConsecutiveErrorType = 'InvalidAIContentOutlineConsecutive'
export const aiContentOutlineResultConsecutiveErrorMessage =
    'AI Outline result is invalid or does not match the page structure also after a retry'
export const aiRequestErrorType = 'AIOutlineContentRequestError'
export const aiRequestErrorMessage = 'AI Content request failed'
export const aiContentTooLongErrorType = 'AIOutlineContentTooLongError'
export const aiContentTooLongErrorMessage = 'Some of the returned content is too long relative to the original content'
export const aiContentBadJsonErrorType = 'AIOutlineContentBadJsonError'
export const aiContentBadJsonErrorMessage = 'AI Content returned unparsable JSON'
export const aiContentUnexpectedError = 'AIOutlineContentUnexpectedError'
export const aiContentUnexpectedErrorMessage = 'An unexpected error occurred while generating AI content'

export const aiVideoGeneratorServerlessUrl = '/_api/dm-server-image-injection/generate-videos'
export const aiSvgGeneratorServerlessUrl = '/_api/dm-server-image-injection/generate-svgs'
export const aiFileUploadServerlessUrl = '/_api/dm-server-image-injection/upload-file'
export const aiFilesUploadServerlessUrl = '/_api/dm-server-image-injection/upload-files'

export const UPLOAD_STATUS = {
    PENDING: 'PENDING',
    READY: 'READY',
    FAILED: 'FAILED'
}
export const imageUploadMaxTryouts = 10
export const imageUploadDelay = 1000
export const generationTimeBudget = 100000
export const aiImageDescriptorUrl = '/_api/wix-privatemedia-proxy-server/v1/files/get-file-by-id'
export const aiImageUploadUrl = '/_api/wix-privatemedia-proxy-server/v1/files/import'
export const aiImageGeneratorServerlessUrl = '/_api/dm-server-image-injection/generate-images-with-hints'

export const getSimilarImageServerlessUrl = '/_api/dm-server-image-injection/generate-similar-images'
export const getMatchingImageServerlessUrl = '/_api/dm-server-image-injection/match-images-to-page'
export const getFittingImageServerlessUrl = '/_api/dm-server-image-injection/fit-images-to-frame'
export const getImageWithNoBackgroundServerlessUrl = '/_api/dm-server-image-injection/remove-images-background'
export const getEditedImageServerlessUrl = '/_api/dm-server-image-injection/edit-images'
export const getUpscaledImageServerlessUrl = '/_api/dm-server-image-injection/upscale-images'
export const getEnhancedImageServerlessUrl = '/_api/dm-server-image-injection/enhance-images'

export const aiImageUnexpectedError = 'AIOutlineImageUnexpectedError'
export const aiImageUnexpectedErrorMessage = 'An unexpected error occurred while generating AI Image'
export const aiImageInjectionValidationErrorMessage = 'AI Image generating request validation failed'
export const aiImageUploadErrorType = 'AiBuilderImageUploadError'
export const aiImageUploadErrorMessage = 'AI Image upload request failed'

export const aiContentMainPageFailedErrorType = 'AIContentMainPageFailedError'
export const aiContentMainPageFailedErrorMessage = 'AI Content failed to generate content for main page'
export const aiContentAllPagesFailedErrorType = 'AIContentAllPagesFailedError'

export const aiContentMissingOnOutlineErrorType = 'AIContentMissingOnOutlineError'
export const aiContentMissingOnOutlineMessage = 'Ai content failed for specific field'
export const aiContentAllPagesFailedErrorMessage =
    'AI Content site suggestion failed for all pages and main page was ignored'
export const aiBusinessNameFieldIdMissingType = 'BusinessNameFieldIdMissing'
export const aiBusinessNameFieldIdMissingMessage = 'BusinessNameFieldId is Missing'

export const aiBusinessNamePathMissingOnObjectType = 'BusinessNamePathIsWrong'
export const aiBusinessNamePathMissingOnObjectMessage = 'BusinessName path is Wrong'
export const aiShorterBusinessNameRequestErrorType = 'AiShorterBusinessNameRequestError'
export const aiShorterBusinessNameRequestErrorMessage = 'AI Content request for shorter business name failed'
export const aiPageSuggestionInteraction = 'ai-content-page-suggestion'
export const aiMultiChoiceCompletionInteraction = 'ai-content-multi-choice-completion'
export const aiLinkGenerationRequestErrorType = 'AiLinkGenerationNameRequestError'
export const aiLinkGenerationRequestErrorMessage = 'AI Content request for link generation failed'
export const aiBuilderInjectionErrorType = 'AiBuilderInjectionError'
export const aiBuilderInjectionErrorMessage = 'AI Content request for new builder injection failed'
export const aiLinkGenerationResultConsecutiveErrorType = 'InvalidLinkGenerationOutlineConsecutive'
export const aiLinkGenerationResultConsecutiveErrorMessage =
    'AI Outline result is invalid or does not match the link generation formant also after a retry'
export const aiBuilderInjectionResultConsecutiveErrorType = 'InvalidBuilderInjectionConsecutive'
export const aiBuilderInjectionResultConsecutiveErrorMessage =
    'AI Builder injection result is invalid or does not match the Builder injection format also after a retry'

export const aiLinkGenerationInteraction = 'ai-link-generation-suggestion'
export const aiLinkGenerationInteractionGetPageOutline = 'ai-link-generation-suggestion-get-page-outline'
export const aiLinkGenerationInteractionFetchLinks = 'ai-link-generation-suggestion-fetch-links'
export const aiLinkGenerationInteractionGenerateLinksDataItems =
    'ai-link-generation-suggestion-generate-links-data-item'
export const blacklistedContentPhrases = [
    "i'm a paragraph",
    'im a paragraph',
    'click here to add your own text and edit me',
    "i'm a great place for you to tell a story and let your users know a little more about you",
    'a great place for you to tell a story and let your users know a little more about you'
].map(phrase => phrase.toLowerCase())

export const blacklistedPageTitleKeywords = ['policy']

export const aiRequestErrorOutlineValidationFailedTag = 'outline-fields-mismatch'
export const aiRequestErrorBlacklistValidationFailedTag = 'blacklist-threshold-exceeded'

export const shortenBusinessNameInteraction = 'shorten-business-name-interaction'

export const imageUploadTryouts = 'image-upload-tryouts'

export const aiStructureMissingOutlineMessage = 'AI Content section suggestion failed - empty outline response'

export const multichoiceLanguage = 'english'

export const proactiveAiBuildSiteContextPromptId = '524b8ef4-7466-495d-bd3b-8d1477465267'
export const proactiveAiAnalysisPromptId = 'cc5e91d5-04b0-4d1e-bf36-a2737c6d3194'

export const proactiveAiAnalyzeErrorType = 'ProactiveAiAnalyzeError'
export const proactiveAiAnalyzeErrorMessage = 'Failed to analyze content with Proactive AI'
export const proactiveAiAnalyzeBadJsonErrorType = 'ProactiveAiAnalyzeBadJsonError'
export const proactiveAiAnalyzeBadJsonErrorMessage = 'Proactive AI analyze returned unparsable JSON'

export const LOGS = {
    IMAGES: {
        GENERATION: 'IMAGES_GENERATION',
        UPLOAD: 'IMAGES_UPLOAD'
    },
    VIDEO: {
        GENERATION: 'VIDEO_GENERATION',
        UPLOAD: 'VIDEO_UPLOAD'
    },
    SVGS: {
        GENERATION: 'SVGS_GENERATION',
        UPLOAD: 'SVGS_UPLOAD'
    }
}

export const ERRORS = {
    IMAGES: {
        GENERATION: 'ImagesGenerationError',
        GENERATION_VALIDATION_ERROR: 'ImagesGenerationValidationError',
        UPLOAD: 'ImagesUploadError',
        EDIT_IMAGES: 'EditImagesError',
        ENHANCE_IMAGES: 'EnhanceImagesError',
        FIT_IMAGES_TO_FRAME: 'FitImagesToFrameError',
        GENERATE_SIMILAR_IMAGES: 'GenerateSimilarImagesError',
        MATCH_IMAGES_TO_PAGE: 'MatchImagesToPageError',
        REMOVE_IMAGES_BACKGROUND: 'RemoveImagesBackgroundError',
        UPSCALE_IMAGES: 'UpscaleImagesError'
    },
    VIDEO: {
        GENERATION: 'VideoGenerationError',
        UPLOAD: 'VideoUploadError'
    },
    SVGS: {
        GENERATION: 'SvgsGenerationError',
        UPLOAD: 'SvgsUploadError'
    }
}
